<template lang="pug">
  main.main#app
    Header
    .main__content
      RouterView(v-slot="{ Component, route }")
        Transition(name="fade" mode="out-in")
          component(:is="Component" :key="route.meta.transitionKey ?? route.fullPath")
    Footer
    Popups
    Transition(name="fade")
      MobileMenu(v-if="uiStore.mobileMenuOpen" class="mobile-menu_open")
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, watch } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'
import Popups from '@/components/common/Popups.vue'
import MobileMenu from '@/components/MobileMenu.vue'
import { useUiStore } from '@/stores/ui'
import { useCatalogStore } from '@/stores/catalog'

const route = useRoute()
const uiStore = useUiStore()
const catalogStore = useCatalogStore()
let stopViewportTracking: (() => void) | undefined

watch(
  () => route.params.locale,
  () => void catalogStore.fetchCategories(),
  { immediate: true },
)

onMounted(() => {
  stopViewportTracking = uiStore.startViewportTracking()
})

onBeforeUnmount(() => {
  stopViewportTracking?.()
})
</script>

<style lang="stylus">
.main
  position relative
  min-height 100vh
  display flex
  flex-direction column
</style>
